import React from 'react'
import {ActionSheet, ActionSheetButton} from 'react-onsenui'
import _ from "underscore";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import Loader from 'react-loader-spinner';

import UserInfoDialog from '../../user/userInfoDialog';
import {showToastMessage} from "../../../modules/toast";
import {GET_JOSA, NAVER_THUMBNAIL_GETTER, SCHEDULE_SORT_KEY_TO_NAME} from "../../../modules/variable/common_variable";
import firebase from 'firebase/app';
import 'firebase/firestore';

class NearPlaceListActionSheet extends React.Component {
    constructor(props) {
        super(props);
        this.scheduleRef = firebase.firestore().collection('user_schedule');
    }

    state = {
        userInfoDialog: {open: false, uid: ''},
        nearScheduleList: {isLoading: false, list: []},
    };

    componentDidMount(){
        if(this.props.placeId){
            this.setState({nearScheduleList: {...this.state.nearScheduleList, isLoading: true}});
            let query = this.scheduleRef.where("scheduleOrder", "array-contains", this.props.placeId.toString()).where("use", "==", true).where("share", "==", true).orderBy("recommend", "desc");
            query.get().then((snapshot) => {
                let qd = [];
                snapshot.forEach((doc) => {
                    if(doc.exists){
                        let d = doc.data();
                        d['DOC_ID'] = doc.id;
                        qd.push(d);
                    }
                });

                this.setState({nearScheduleList: {...this.state.nearScheduleList, isLoading: false, list: qd}});
            });
        }
    }

    showUserInfoDialog = (event, uid) => {
        event.preventDefault();
        event.stopPropagation();
        this.setState({userInfoDialog: {...this.state.userInfoDialog, open: true, uid: uid}});
    };

    goToScheduleList = (type, parameter) => {
        this.props.history.push({
            pathname: '/listSchedule',
            state: {type: type, parameter: parameter}
        });
    };

    showTargetScheduleFromHome = (event, target) => {
        event.preventDefault();
        event.stopPropagation();
        this.props.showTargetSchedule(target);
    };

    render() {
        const NPL = this.state.nearScheduleList.list;

        return (
            <div>
                <ActionSheet className="common-action-sheet" isOpen={true} animation='default' modifier={'material'} onCancel={() => this.props.hide()} isCancelable={true}>
                    <div className="action-sheet-title action-sheet-title--material">
                        {this.props.placeName}<small>{GET_JOSA(this.props.placeName, '이')} 포함된 일정</small>
                    </div>
                    <ul className="list--material list common-action-sheet-list">
                        {
                            !this.state.nearScheduleList.isLoading && NPL.length === 0 ?
                                <li className="list-item list-item--material">
                                    <div className="list-item__center list-item--material__center ">
                                        <div className="list-item__title list-item--material__title text-center">
                                            {this.props.placeName}{GET_JOSA(this.props.placeName, '이')} 포함된 일정이 없습니다.
                                        </div>
                                    </div>
                                </li>
                                :
                                null
                        }

                        {
                            !this.state.nearScheduleList.isLoading ?
                                NPL.map((e, i) => {
                                    return (
                                        <li key={['near', 'schedule', 'list', i].join('_')} className="list-item list-item--material">
                                            <div className="list-item__left list-item--material__left" onClick={(event) => this.showTargetScheduleFromHome(event, e)}>
                                                <img className="list-item__thumbnail"
                                                     src={NAVER_THUMBNAIL_GETTER(e.schedule[e.scheduleOrder[e.thumbnailIndex ? e.thumbnailIndex : 0]])}
                                                     onError={(event) => {
                                                         event.target.src = "https://fakeimg.pl/100x100/?text=No Image"
                                                     }} alt={e.schedule[e.scheduleOrder[e.thumbnailIndex ? e.thumbnailIndex : 0]].name}/>
                                            </div>
                                            <div className="list-item__center list-item--material__center" onClick={(event) => this.showTargetScheduleFromHome(event, e)}>
                                                <div className="list-item__title">{e.title}</div>
                                                <div className="list-item__subtitle">
                                                    <span onClick={(event) => this.showUserInfoDialog(event, e.uid)}>
                                                        {e.nickname}
                                                    </span>
                                                    {
                                                        e.sort ?
                                                            <small style={{marginLeft: '4px'}}>
                                                                {
                                                                    e.sort ?
                                                                        Object.keys(e.sort).map((k, j) => {
                                                                            if(e.sort[k] === true){
                                                                                return (
                                                                                    <span key={['near', 'schedule', 'sort', i, j].join('_')} className="notification notification--material notification-sort">{SCHEDULE_SORT_KEY_TO_NAME[k]}</span>
                                                                                )
                                                                            }
                                                                        })
                                                                        :
                                                                        null
                                                                }
                                                            </small>
                                                            :
                                                            null
                                                    }
                                                </div>
                                            </div>
                                            <div className="list-item__right list-item--material__right">
                                                <span className="notification notification--material" onClick={() => this.goToScheduleList('SHARE', {code: e.representative.district.code})}>{e.representative.district.name.substring(0,3)}</span>
                                            </div>
                                        </li>
                                    )
                                })
                                :
                                <li className="list-item list-item--material">
                                    <div className="list-item__title list-item--material__title text-center">
                                        <Loader type="ThreeDots" color="#00BFFF" height={40} width={40} />
                                    </div>
                                </li>
                        }
                    </ul>
                    <ActionSheetButton className="action-sheet-close" onClick={() => this.props.hide()} icon={'md-close'} modifier={'material'}>추천 장소 닫기</ActionSheetButton>
                </ActionSheet>

                {
                    this.state.userInfoDialog.open ?
                        <UserInfoDialog open={true} uid={this.state.userInfoDialog.uid} hide={() => this.setState({userInfoDialog: {...this.state.userInfoDialog, open: false}})}/>
                        :
                        null
                }
            </div>
        )
    }
}

const mapStateToProps = ({ user }) => ({
    userInfo: user.userInfo
});

const mapDispatchToProps = dispatch => ({
    showToastMessage: message => dispatch(showToastMessage(message))
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(NearPlaceListActionSheet))

